import { render, staticRenderFns } from "./AlertPanel.vue?vue&type=template&id=63382091&scoped=true&"
import script from "./AlertPanel.vue?vue&type=script&lang=js&"
export * from "./AlertPanel.vue?vue&type=script&lang=js&"
import style0 from "./AlertPanel.vue?vue&type=style&index=0&id=63382091&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63382091",
  null
  
)

export default component.exports